module.exports = __webpack_public_path__ + "img/concrete-hole-decal-14.eec8ad85.png";